export const DOCS_STORE_KEY = 'docs';
export const DOCS_SERVICE_KEY = 'docs';
export const DOCS_API_URL = '/api/v1/helpscout/';
